import axios from "axios";
import authHeader from "./AuthHeader";
import AuthService from "./AuthService";

const api_url = process.env.REACT_APP_URL;
const slug = AuthService.getLng() + "/tirebooking/send_notification/";
const bodyParameters = {
};

export class NotificationService {

  sendNotification(subject, text, email) {
    return axios
      .post(api_url + slug, { subject, text, email }, {
        headers: authHeader(),
      })
      .then((res) => res.data.results);
  }


}
